var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-divider',{key:_vm.entry.id + '_divider',class:[_vm.entryTimeOverlap(_vm.entry.id) && ((!_vm.dayEntries[_vm.index-1] || (_vm.dayEntries[_vm.index-1] && _vm.entryTimeOverlap(_vm.dayEntries[_vm.index-1].id))) && (_vm.dayEntries[_vm.index+1] && _vm.entryTimeOverlap(_vm.dayEntries[_vm.index+1].id))) && 'border-bottom-red']})
}
var staticRenderFns = []

export { render, staticRenderFns }